import { IStudentCourse, TModuleView } from "../typings/Course";
import http from "./client";


async function editAnnounce(courseId: string | number, {
  editor, announce
}: {editor: string, announce: string}): Promise<string> {
  const response = await http.post('/api/course/editannounce', {editor, announce}, {
    params: {
      course_id: courseId
    }
  })
  return response.data.announce;
}

async function deleteAnnounce(courseId: string | number) {
  const response = await http.post('/api/course/deleteannounce', null, {
    params: {
      course_id: courseId
    }
  })
}

async function getById(courseId: string | number) {
  const response = await http.get('/api/course/get', {
    params: {
      course_id: courseId
    }
  });
  return response.data;
}

async function getByIdStudent(courseId: string | number): Promise<IStudentCourse> {
  const response = await http.get('/api/course/student-by-id', {
    params: {
      id: courseId
    }
  });
  return response.data.data;
}

async function updateView(courseId: string| number, type: TModuleView) {
  await http.post('/api/course/module-view/', {
    type
  }, {
    params: {
      course_id: courseId
    }
  })
}


async function getSettings(courseId: number | string, groupId?: string | number) {
  const res = await http.get('/api/shop/coursesettings', {
    params: {
      course_id: courseId,
      group_id: groupId,
    }
  });
  return res.data;
}

const course = {
  getById, getByIdStudent, editAnnounce, deleteAnnounce, updateView, getSettings
}

export default course;